import React, { Fragment, useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useTable, useGlobalFilter, useFilters, usePagination } from "react-table";
import { TailSpin } from 'react-loader-spinner';
import { COLUMNS } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";
import { getAllPresupuestos } from "../../../Api/presupuesto";
import * as XLSX from 'xlsx';
import Condiciones from "./Condiciones";

const Presupuestos = () => {
  const Editdata = {
    subtotal: 0,
    descuento: 0,
    total: 0,
    obs: "",
    validoHasta: "",
    fecha: "",
    itemsPresupuesto: [{ codigo: "", descripcion: "", cantidad: 1, precio: 0, subtotal: 0, descuento: 0, total: 0 }],
    condiciones: "",
  };

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const assigmentValue = useCallback(async () => {
    try {
      const result = await getAllPresupuestos();
      console.log(result)
      setData([...result]);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  const columns = useMemo(() => COLUMNS, []);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  const handleExportToExcel = () => {
    // Prepare data for Excel
    const exportData = data.map((item) => ({
      ID: item.idpresupuestos,
      Cliente: item.nombre_cliente,
      Telefono : item.telefono_cliente,
      Estado: item.estado,
      Fecha: item.fecha,
      'Válido Hasta': item.validohasta,
      Asesor: item.asesor,
      'Monto Total' : item.monto_total,
      Observaciones: item.obs,
      // Add other fields as needed
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Presupuestos");
    // Generate Excel file and trigger download
    XLSX.writeFile(wb, `Presupuestos_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return (
    <Fragment>
      <div className="col-md-12">
        <div className="card">
          <div className="card-body pb-0">
            <Row className="justify-content-between align-items-center">
              <Col>
                <Card.Title>Presupuestos</Card.Title>
              </Col>
              <Col className="text-end">
                <Link to="/nuevopresupuesto">
                  <Button variant="primary" className="me-2">
                    Agregar
                  </Button>
                </Link>
                <Button variant="success" onClick={handleExportToExcel} disabled={loading || data.length === 0}>
                  Exportar a Excel
                </Button>
              </Col>
            </Row>
          </div>
          <div className="chart-wrapper">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <GlobalFilter
                    filter={globalFilter}
                    setFilter={setGlobalFilter}
                  />
                  <TailSpin
                    height="30"
                    width="30"
                    color="black"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={loading}
                  />
                  <br />
                  <table
                    {...getTableProps()}
                    className="table dataTable display"
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th {...column.getHeaderProps()}>
                              {column.render("Header")}
                              {column.canFilter
                                ? column.render("Filter")
                                : null}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="">
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => (
                              <td {...cell.getCellProps()} className="p-2">
                                {'\u00A0'} {'\u00A0'} {'\u00A0'} {'\u00A0'} {'\u00A0'}
                                <Link to={`/fichapresupuesto/${row.values.idpresupuestos}`}>
                                  {cell.render("Cell")}
                                </Link>
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-between">
                    <span>
                      Página{" "}
                      <strong>
                        {pageIndex + 1} de {pageOptions.length}
                      </strong>
                    </span>
                    <span className="table-index">
                     Ir a página :{" "}
                      <input
                        type="number"
                        className="ml-2"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(pageNumber);
                        }}
                      />
                    </span>
                  </div>
                  <div className="text-center mb-3">
                    <div className="filter-pagination mt-3">
                      <button
                        className="previous-button"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                      >
                        {"<<"}
                      </button>
                      <button
                        className="previous-button"
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                      >
                        Anterior
                      </button>
                      <button
                        className="next-button"
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                      >
                        Siguiente
                      </button>
                      <button
                        className="next-button"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                      >
                        {">>"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div className="card">
          <Condiciones></Condiciones>
         </div>
      </div>
    </Fragment>
  );
};

export default Presupuestos;